export class EddiePoItemVariant {

    sizeCode: string;
    size: string;
    upc: string;
    sku:string;
    quantityPerInnerPack:string;
    retailPrice:string;
    quantity: string;
    unit:string;
    unitCost: string;
    cost:string;


    ratio:string;


   
}